import SlideFirstOutline from './SlideFirstOutline'

export default SlideFirstOutline
// eslint-disable-next-line import/export
export * from './SlideFirstOutline'
